// LOT 9.21 · typographie française des textes affichés (réponses GET) : accords « 1 factures », virgule décimale, trous « ·  », dates AAAA-MM-JJ dans une phrase
import axios from 'axios';

const NOMS = 'factures|équipements|produits|plats|tâches|fournisseurs|jours|lignes|fiches|articles|commandes|ingrédients|cartes|lieux|services|alertes|livraisons';
const MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
const CLE_BRUTE = /(^|_)(id|ids|url|href|to|path|slug|email|key|code|token|unite|unit|date|at|iso|valeur_brute|raw|query|q|tel|phone)$/i;

export const francise = (t) => {
  if (typeof t !== 'string' || !/\s/.test(t) || /https?:|@|\/api\//.test(t)) return t;
  return t
    .replace(new RegExp(`(^|[^\\d,.])1 (${NOMS})\\b`, 'g'), (m, a, n) => `${a}1 ${n.replace(/x$|s$/, '')}`)
    .replace(/(^|[\s(+−-])(\d+)\.(\d+)(?=\s|$|\s?[%/a-zA-Zé€]|\))/g, '$1$2,$3')
    .replace(/·\s{2,}/g, '· — ').replace(/\s{2,}·/g, ' — ·')
    .replace(/\b(20\d\d)-(\d\d)-(\d\d)\b(?!T)/g, (m, y, mo, d) => `${parseInt(d, 10)} ${MOIS[parseInt(mo, 10) - 1]} ${y}`);
};

const parcourt = (v, k = '') => {
  if (typeof v === 'string') return CLE_BRUTE.test(k) ? v : francise(v);
  if (Array.isArray(v)) return v.map((x) => parcourt(x, k));
  if (v && typeof v === 'object') { for (const c of Object.keys(v)) v[c] = parcourt(v[c], c); return v; }
  return v;
};

axios.interceptors.response.use((r) => {
  if ((r.config?.method || 'get') === 'get' && r.data && typeof r.data === 'object' && !/\/(export|download|pdf|csv)/.test(r.config?.url || '')) r.data = parcourt(r.data);
  return r;
});

// 9.21 · nom propre d'un produit : sans le conditionnement entre parenthèses, en casse normale
export const nomPropre = (n) => {
  if (typeof n !== 'string') return n;
  const t = n.replace(/\s*\([^)]*\d[^)]*\)\s*/g, ' ').replace(/\s{2,}/g, ' ').trim() || n;
  const maj = (t.match(/[A-ZÀ-Ý]{2,}/g) || []).join('').length > t.replace(/[^A-Za-zÀ-ÿ]/g, '').length / 2;
  if (!maj) return t;
  const low = t.toLocaleLowerCase('fr');
  return low.charAt(0).toLocaleUpperCase('fr') + low.slice(1);
};

// 9.21 · relecture des textes affichés : « 1 factures » → « 1 facture », « 1.4 / kg » → « 1,4 / kg »
const SING = 'factures|équipements|produits|plats|tâches|fournisseurs|jours|lignes|fiches|articles|commandes|ingrédients|cartes|lieux|services|alertes|livraisons|décisions|équipiers|préparations|zones|relevés|vendus|comptés|heures|missions|candidats|postes|messages|crédits|étiquettes|inventaires|écarts|hausses|catégories|recettes|produits';
const RE_SING = new RegExp(`(^|[^\\d,.\\u202f\\u00a0 ]\\s?|\\s)1 (${SING})\\b`, 'g');
const RE_DEC = /(^|[\s(+−–-])(\d+)\.(\d+)(?=\s|$|[%/a-zA-Zé€)·,;:]|\u202f|\u00a0)/g;
const SAUTE = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'CODE', 'PRE', 'INPUT']);
const relit = (n) => {
  const v = n.nodeValue; if (!v || !/\d/.test(v) || SAUTE.has(n.parentNode?.nodeName) || /https?:|@|\/api\//.test(v) || n.parentNode?.closest?.('[data-notypo]')) return;
  const w = v.replace(RE_SING, (m, a, x) => `${a}1 ${x === 'lieux' ? 'lieu' : x.replace(/s$/, '')}`).replace(RE_DEC, '$1$2,$3');
  if (w !== v) n.nodeValue = w;
};
const parcourtDom = (r) => { if (r.nodeType === 3) return relit(r); if (r.nodeType !== 1 || SAUTE.has(r.nodeName)) return; const it = document.createTreeWalker(r, NodeFilter.SHOW_TEXT); let t; while ((t = it.nextNode())) relit(t); };
if (typeof window !== 'undefined' && window.MutationObserver) {
  const go = () => { parcourtDom(document.body); new MutationObserver((ms) => ms.forEach((m) => (m.type === 'characterData' ? relit(m.target) : m.addedNodes.forEach(parcourtDom)))).observe(document.body, { childList: true, subtree: true, characterData: true }); };
  if (document.body) go(); else window.addEventListener('DOMContentLoaded', go);
}
